/* @generated */
import * as React from "react";
import { contentIconRecipe } from "../styles/index.css.esm.js";
import classNames from "classnames";
import { useThemedStyle } from "../hooks/useThemedStyle.esm.js";
import { BackgroundFileSmall } from "./_background/background-file-small.esm.js";
import { useCompositeContentIconViewBox } from "../hooks/useContentIconViewbox.esm.js";
const FilePowerpointSmall = ({
  className,
  hasWhitespace = true,
  over = "base",
  hasBackground = true,
  ...props
}) => {
  const cls = classNames([
    "dig-ContentIcon",
    className,
    "dig-ContentIcon--small",
    {
      "dig-ContentIcon--overBase": over === "base",
      "dig-ContentIcon--overSubtle": over === "subtle",
      "dig-ContentIcon--hasNoBackground": !hasBackground
    },
    contentIconRecipe({ over, hasNoBackground: !hasBackground })
  ]);
  const style = useThemedStyle({ over });
  const viewBox = useCompositeContentIconViewBox({ hasWhitespace, size: "small" });
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      viewBox,
      fill: "none",
      role: "presentation",
      focusable: "false",
      width: 40,
      height: 40,
      className: cls,
      "data-testid": "FilePowerpointSmall",
      style,
      ...props
    },
    hasBackground ? /* @__PURE__ */ React.createElement(BackgroundFileSmall, null) : null,
    /* @__PURE__ */ React.createElement("path", { d: "m7 8 7-1v11.333l-7-1V8Z", fill: "#D24726" }),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M10.111 13.333V15H9v-5h1.61c1.149 0 1.723.531 1.723 1.594 0 .502-.165.908-.496 1.22-.329.309-.768.52-1.32.52h-.406Zm0-2.468v1.558h.32c.547 0 .82-.262.82-.788 0-.513-.273-.77-.82-.77h-.32Z",
        fill: "#fff"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M13.334 8h5.349c.175 0 .317.142.317.318v8.698a.318.318 0 0 1-.317.317h-5.35V8Z",
        fill: "#D24726"
      }
    ),
    /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "M14 8.667h4.333v8H14z" }),
    /* @__PURE__ */ React.createElement("path", { fill: "#D24726", d: "M14 14.667h3.333V14H14zM14 16h3.333v-.667H14z" }),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.012 10H15v1.667h1.667A1.667 1.667 0 1 1 15 10h.012Z",
        fill: "#D24726"
      }
    ),
    /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.333 11h-1.666V9.334H14", fill: "#D24726" })
  );
};
export {
  FilePowerpointSmall
};
